import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/creator-codes")({
	component: CreatorCodesLayout,
})

function CreatorCodesLayout() {
	return <Outlet />
}
